import type ISchoolRepository from '@/core/domain/school/core/ISchoolRepository'
import type School from '@/core/domain/school/core/School'

export default class FetchAllSchoolsUseCase {
  private readonly schoolRepository: ISchoolRepository

  constructor(schoolRepository: ISchoolRepository) {
    this.schoolRepository = schoolRepository
  }

  async execute(): Promise<School[]> {
    return await this.schoolRepository.fetchAllSchools()
  }
}
